import { integerBetween, integerMin, maxLength, numeric } from '@reliance/forms-js/lib/validation';
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Select } from '../form/Select';
import { InputType, TextInput } from '../form/TextInput';

const ConfigurationAudioFields: React.FC = () => (
  <div className="mt-2">
    <div className="text-muted small mb-1">Audio</div>
    <Row>
      <Col md={6}>
        <TextInput
          label="Device"
          name="configuration.audio.device"
          helperText='ALSA capture device (e.g. "hw:1,0")'
          validationRules={[maxLength(255)]}
        />
      </Col>
      <Col md={6}>
        <TextInput
          label="Capture control"
          name="configuration.audio.captureControl"
          helperText='ALSA capture control (e.g. "Mic")'
          validationRules={[maxLength(255)]}
        />
      </Col>
    </Row>
    <Row className="mt-2">
      <Col md={4}>
        <TextInput
          label="Buffer size"
          name="configuration.audio.bufferSize"
          type={InputType.number}
          validationRules={[numeric, integerMin(1)]}
        />
      </Col>
      <Col md={4}>
        <TextInput
          label="Capture gain %"
          name="configuration.audio.captureGainPercent"
          type={InputType.number}
          validationRules={[numeric, integerBetween(0, 100)]}
        />
      </Col>
      <Col md={4}>
        <TextInput
          label="Ring buffer multiplier"
          name="configuration.audio.ringBufferMultiplier"
          type={InputType.number}
          validationRules={[numeric, integerBetween(2, 64)]}
        />
      </Col>
    </Row>
    <Row className="mt-2">
      <Col md={4}>
        <Select label="Disable AGC" name="configuration.audio.disableAgc">
          <option value=""></option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </Select>
      </Col>
      <Col md={4}>
        <Select label="Auto gain" name="configuration.audio.autoGain">
          <option value=""></option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </Select>
      </Col>
      <Col md={4}>
        <TextInput
          label="Auto-gain target dBFS"
          name="configuration.audio.autoGainTargetDbfs"
          type={InputType.number}
          validationRules={[numeric]}
        />
      </Col>
    </Row>
  </div>
);

export default ConfigurationAudioFields;
